import React from 'react';
import { useSpring, animated } from 'react-spring';
import { FaCode, FaPaintBrush, FaCube, FaBullhorn, FaRobot, FaBug } from 'react-icons/fa';

const icons = [FaCode, FaPaintBrush, FaCube, FaBullhorn, FaRobot, FaBug];

const ServiceBlock = ({ service }) => {
  const props = useSpring({
    opacity: 1,
    transform: 'translateY(0)',
    from: { opacity: 0, transform: 'translateY(-20px)' },
  });

  const Icon = icons[service.id - 1];

  return (
    <animated.div style={props} className="service-block">
      <div className="icon-container">
        <Icon size={40} />
      </div>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
    </animated.div>
  );
};

export default ServiceBlock;
